import isUndefined from 'lodash/isUndefined'

import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import $api2 from '@/plugins/axiosInstance2.js'
import CONST from '@/const'

const state = {
    ownerList: null   // 권리자 리스트
}

const getters = {
    ownerList(state){
      return state.ownerList
    }
}

const mutations = {
    OWNERLIST(state, payload){
        // 권리자 리스트
        state.ownerList = payload
    }
}

const actions = {
  GETUSER: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/user', params: payload
    })
        .then(result =>{
          return result.data
        })
    }
  },
  PUTUSER: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'put', url: '/user/'+ payload.id, data: payload.params})
        .then(result =>{
          return result
        })
    }
  },
  POSTUSER: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'post', url: '/user', data: payload.params})
        .then(result =>{
          return result
        })
    }
  },
  POST_USER_FROM_EMAIL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: '/admin/user/from-email', data: payload })
        .then(result => result.data)
    }
  },
  POSTMEMO: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'post', url: '/'+ payload.role + '/' + payload.id + '/memo', data: {text: payload.data}})
    }
  },
  DELETEMEMO: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'delete', url: '/'+ payload.role + '/' + payload.id + '/memo/' + payload.memo_id })
      .then(result =>{
        return result
      })
    }
  },
  GETMEMOLIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'get', url: '/' + payload.role + '/' + payload.id + '/memo',params: payload.params})
      .then(result => {
        return result
      })
    }
  },
  GETFILELIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'get', url: '/' + payload.role + '/' + payload.id + '/file',params: payload.params})
      .then(result => {
        return result
      })
    }
  },
  POSTFILE: {
    root: true,
    handler(namespacedContext, payload) {
      const formData = new FormData()
      formData.append('file', payload.file, payload.file.name)
    //   return $api({ method: 'post', url: '/file', data: formData, headers: {
    //     'content-Type': 'multipart/form-data'
    // }, timeout: 30000})
    //     .then(result =>{
    //       return result
    //     })
      return $api({method: 'post', url: '/' + payload.role + '/' + payload.id + '/file',data: formData,headers: {
        'content-Type': 'multipart/form-data'
      }})
      .then(result => {
        return result
      })
    }
  },
  DELETEFILE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'delete', url: '/' + payload.role + '/' + payload.id + '/file/' + payload.file_id })
      .then(result => {
        return result
      })
    }
  },

  TRANSACTION_LIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'get', url: '/user/' + payload.id + '/transaction',params: payload.params})
      .then(result => {
        return result
      })
    }
  },
  GETCONTRACTOR_LICENSORS: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'get', url: '/contractor/'+ payload.id + "/licensors", params: payload.params})
      .then(result =>{
        return result
      })
    }
  },

  POSTCONTRACTOR_LICENSORS: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'post', url: '/contractor/'+ payload.id + "/licensors", data: payload.params})
      .then(result =>{
        return result
      })
    }
  },
  DELETECONTRACTOR_LICENSOR: {
    root: true,
    handler(namespaceContext, payload){
      return $api({method: "delete", url: '/contractor/' + payload.id + '/licensors/' + payload.licensor_id})
      .then(result =>{
        return result
      })
    }
  },
  DELETE_CONTRACTOR_FILE: {
    root: true,
    handler(namespaceContext, payload) {
      return $api({method: "delete", url: "/contractor/" + payload.id + "/file/" + payload.file_id})
      .then(result =>{
        return result
      })
    }
  },
  DELETE_LICENSOR_FILE: {
    root: true,
    handler(namespaceContext, payload) {
      return $api({method: "delete", url: "/licensor/" + payload.id + "/file/" + payload.file_id})
      .then(result =>{
        return result
      })
    }
  },
  PUTCONTRACTOR: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'put', url: '/contractor/'+ payload.id, data: payload.params})
      .then(result =>{
        return result
      })
    }
  },
  
  GETCONTRACTOR: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/contractor/'+ payload})
        .then(result =>{
          return result
        })
    }
  },
  GETALBUMLIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/album', params: payload})
        .then(result =>{
          return result
        })
    }
  },
  GETOFFSETTINGALBUMLIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/licensor/' + payload.id + '/album', params: payload.params})
        .then(result =>{
          return result.data
        })
    }
  },
  GETALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/album/' + payload})
        .then(result =>{
          return result
        })
    }
  },
  GETCONTRACTOR: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/contractor/'+ payload})
        .then(result =>{
          return result
        })
    }
  },
  GETLICENSORLIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/licensor', params: payload})
        .then(result =>{
          return result
        })
    }
  },
  POSTFILEUPLOAD: {
    root: true,
    handler(namespacedContext, payload) {
      const formData = new FormData()
      formData.append('file', payload, payload.name)
      return $api({ method: 'post', url: '/file', data: formData, headers: {
        'content-Type': 'multipart/form-data'
    }, timeout: 30000})
        .then(result =>{
          return result
        })
    }
  },
  POST_EXCEL_FILE_UPLOAD: {
    root: true,
    handler(namespaceContext, payload) {
      const formData = new FormData()
      formData.append('file', payload.file, payload.file.name)
      formData.append('json', JSON.stringify(payload.data))

      return $api({method: 'post', url: '/user/import', data: formData, 
        headers: {'content-Type': 'multipart/form-data'}, timeout: 30000})
        .then(result =>{
          return result
        })
    }
  },
  // DELETEFILE: {
  //   root: true,
  //   handler(namespacedContext, payload) {
  //     return $api({ method: 'delete', url: '/file/'+ payload})
  //       .then(result =>{
  //         return result
  //       })
  //   }
  // },
  DELETE_ADVANCEPAYMENT_FILE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: "delete", url: '/licensor/' + payload.licensor_id + "/advancepayment/" + payload.advancepayment_id + "/file/" + payload.file_id})
      .then(result =>{
        return result
      }).catch(error => console.log("advancepayment file fail ::", error))
    }
  },
  POSTADVANCEPAYMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/licensor/' + payload.id + '/advancepayment', data: payload.params})
      .then(result =>{
        return result
      })
    }
  },
  POSTADVANCEPAYMENT_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/licensor/' + payload.id + '/advancepayment/' + payload.advancepayment_id + '/album', data: payload.params.albums})
      .then(result =>{
        return result
      })
    }
  },
  GETADVANCEPAYMENT_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/licensor/' + payload.id + '/advancepayment/' + payload.advancepayment_id + '/album'})
      .then(result =>{
        return result.data
      })
    }
  },
  DELETEADVANCEPAYMENT_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'delete', url: '/licensor/' + payload.id + '/advancepayment/' + payload.advancepayment_id + '/album/' + payload.album_id})
      .then(result => {
        return result
      })
    }
  },
  POSTADVANCEPAYMENT_FILE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/licensor/' + payload.id + '/advancepayment/' + payload.advancepayment_id + '/file', data: payload.params.files})
      .then(result =>{
        return result
      })
    }
  },
  GETADVANCEPAYMENT_FILE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/licensor/' + payload.id + '/advancepayment/' + payload.advancepayment_id + '/file'})
      .then(result =>{
        return result
      })
    }
  },
  GETADVANCEPAYMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/licensor/' + payload.id + '/advancepayment', params: payload.params})
      .then(result =>{
        return result.data
      })
    }
  },
  GET_USER: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/user/' + payload})
      .then(result =>{
        return result
      })
    }
  },
  GET_USER_EXCEL : {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/user/export',params :  payload, responseType: 'blob' })
        .then(result =>{return result})
    }
  },


  // 유저 통계 , 통계 엑셀
  // id : user id
  // url  : album, track, artist , country, monthly, store, track
  // 
  GET_USER_STATS: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/user/' + payload.id + `/salesline/stats-${payload.url}` ,params : payload.params})
      .then(result =>{
        return result.data
      })
    }
  },
  GET_USER_STATS_EXCEL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/user/' + payload.id + `/salesline/stats-${payload.url}/excel`,data : payload.params,responseType: 'blob'})
      .then(result =>{
        return result
      })
    }
  },
  GET_USER_STATS_POPULAR: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/user/' + payload.id + `/salesline/stats-${payload.url}/popular` ,params : payload.params})
      .then(result =>{
        return result.data
      })
    }
  },
  GET_LICENSOR_TRACKLIST_EXCEL : {
    root: true,
    handler(namespacedContext, payload) {
      
      return $api({ method: 'get', url: `/licensor/${payload.id}/tracklist`, params : payload.params, })
        .then(result =>{return result})
    }
  },
  GET_USER_SETTLEMENT_EXCEL : {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'POST', url: `/user/${payload.id}/salesline/excel`, data : payload.params, responseType: 'blob'})
        .then(result =>{return result})
    }
  },
  POST_REQUEST_NOTIFICATION: {
    // {
    //   "album_name": "Album Name",
    //   "artist_name": "Artist Name",
    //   "release_date": "Release Date",
    //   "remarks": "내일 까지 제출 부탁드립니다. (테스트))"
    // }
    
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/licensor/' + payload.id + '/notification/album_request_data' , data: payload.params})
      .then(result =>{
        return result
      })
    }
  },
  GET_PERMISSION_LIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/permission',params:{page:0,limit:50}})
        .then(result =>{
          return result
        })
    }
  },
  GET_USER_DETAIL_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({method: 'get', url: '/admin/user/'+ payload.id, data: payload.params})
        .then(result =>{
          return result.data
        })
    }
  },
  PUTUSER: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({method: 'put', url: '/admin/user/'+ payload.id, data: payload.params})
        .then(result =>{
          return result
        })
    }
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
